import { render, staticRenderFns } from "./CouponEmptyState.vue?vue&type=template&id=b8bf6d3a&scoped=true&"
import script from "./CouponEmptyState.vue?vue&type=script&lang=js&"
export * from "./CouponEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./CouponEmptyState.vue?vue&type=style&index=0&id=b8bf6d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bf6d3a",
  null
  
)

export default component.exports